import script from "./terminal-head.vue?vue&type=script&lang=ts&setup=true"
export * from "./terminal-head.vue?vue&type=script&lang=ts&setup=true"

import "./terminal-head.vue?vue&type=style&index=0&id=5b691be1&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b691be1"]])

export default __exports__